import React, { useState, useEffect } from "react";

import FeedBack from "@techsoftware/happay-widgets/FeedBack";

import "./style.css";

import Api from "constants/api";
import * as FeedbackSuveyAction from "actions/feedbackSurveyAction";
import UserInfoStores from "stores/userInfoStores";
import FeedbackStore from "stores/feedbackSurveyStore";
import i18n from "../../i18nNext";

const FeedbackSurvey = () => {
    const initState = {
        isShowPopup: false,
        surveyData: {},
        sliderValue: null,
        configData: {}
    };
    const [state, setState] = useState(initState);

    const { surveyData, isShowPopup, sliderValue, configData } = state;

    const feedbackStoreChange = (type, onlyFetch) => {
        if (type === "CHECK_SURVEY_CONFIG_DATA") {
            const eventName = FeedbackStore._getEventName();

            const reqData = {
                eventName,
                orgId: Api._getKey("org_id"),
                userId: Api._getKey("cid"),
                action: "getSurveyData"
            };
            FeedbackSuveyAction.getSurveyData(reqData, onlyFetch);
        } else if (type === "GET_FEEDBACK_SURVEY_DATA") {
            const surveyData = FeedbackStore._getFeedbackSurveyData();
            const { isSurveryRequired, question, configData } = surveyData;
            if (isSurveryRequired && !Api._getKey("isSkipSurvey")) {
                setState({
                    ...state,
                    surveyData: JSON.parse(question),
                    isShowPopup: true,
                    configData: configData
                });
            }
        } else if(type === "SUBMIT_FEEDBACK_SURVEY") {
            setState({
                ...state,
                isShowPopup: false
            });
            const eventName = FeedbackStore._getEventName();
            if (eventName === "REPORT_APPROVAL") {
                window.close();
            }
        }
    };

    useEffect(() => {
        FeedbackStore.on("change", feedbackStoreChange);

        // Un Mounting
        return () => {
            FeedbackStore.removeListener("change", feedbackStoreChange);
        };
    }, [state]);

    const onClickSendFeedBack = (event, commentValue, slideValue) => {
        const userInfo = UserInfoStores.getAllUserInfoStores();
        const eventName = FeedbackStore._getEventName();

        const reqData = {
            orgId: userInfo?.org_id,
            userId: userInfo?.happay_id,
            rating: slideValue,
            answer: commentValue,
            submittedDuration: `${new Date(configData?.start_date)} to ${new Date(configData?.end_date)}`,
            submitted_date_time: `${new Date()}`,
            submitted_trigger_event: eventName
        };

        FeedbackSuveyAction.postSurveyData(reqData);
        setState(initState);
    };

    const onClickSkipNow = () => {
        setState({
            ...state,
            isShowPopup: false
        });
        Api._setKey("isSkipSurvey", true);
        const eventName = FeedbackStore._getEventName();
        if (eventName === "REPORT_APPROVAL") {
            window.close();
        }
    };

    const showListOfQuestions = () => {
        if (sliderValue === null) {
            return null;
        }
        let val = 0;
        if (sliderValue >= 6 && sliderValue <= 8) {
            val = 1;
        } else if (sliderValue > 8 && sliderValue <= 10) {
            val = 2;
        }
        return (
            <div className="fw-600 font-24">
                {surveyData?.[val]}
            </div>
        );
    };

    const onClickContinue = (e, value) => {
        setState({
            ...state,
            sliderValue: value
        });
    };

    if (!isShowPopup) {
        return null;
    }

    return (
        <FeedBack
            dialogTitle={<img src={"/assets/images/expense_logo.png"} alt="product-logo" height={40} />}
            contentHeader={i18n.t("common.feedbackRecommend")}
            openNpsFeedBackDialog={isShowPopup}
            onClickSkipNow={onClickSkipNow}
            onClickContinue={onClickContinue}
            showListOfQuestions={showListOfQuestions()}
            onClickSendFeedBack={onClickSendFeedBack}
        />
    );
};

export default FeedbackSurvey;
